import { computed, unref } from 'vue';

export function useCardShortFormattedDate(date) {
  const dateParts = computed(() => {
    const formattedDate = unref(date);
    if (!formattedDate) {
      return null;
    }
    // Matches 'Mmm DD', 'Month DD', 'Mmm. DD', for now we only have 'Mmm DD' but this can be expanded
    const regex = /([A-Z][a-z]{2,8})\.?\s*,?\s*(\d{1,2})/;
    const match = formattedDate.match(regex);

    if (match) {
      return {
        month: match[1].substring(0, 3), // Ensure month is always 3 letters
        day: match[2],
      };
    }
    return null;
  });

  const month = computed(() => {
    return dateParts.value ? dateParts.value.month : '';
  });
  const day = computed(() => {
    return dateParts.value ? dateParts.value.day : '';
  });

  return {
    month,
    day,
  };
}
